import React from 'react';
import ModerationItemDetailSection from '../../../sections/AdminDashboard/Moderation/ModerationItemDetail';

const ModerationItemDetail = () => {
  return <ModerationItemDetailSection />;
};

export default ModerationItemDetail;


